/**
 * Generated from MonsterScreenLayout.fla
 */
/* tslint:disable */
function $(e:any,t:number|string,o:number[]|{():any},a?:any){if("object"==typeof o)e[t]=o;else{"number"==typeof t&&!e[t]&&e.elementFactory&&(e[t]=e.elementFactory(t,a)),e=e[t],o.call(e);for(const t in a)a.hasOwnProperty(t)&&("w"===t?e.width=a[t]:"h"===t?e.height=a[t]:"sx"===t&&e.scale?e.scale.x=a[t]:"sy"===t&&e.scale?e.scale.y=a[t]:"r"===t?e.rotation=a[t]:e[t]=a[t]);e.onLayout&&e.onLayout()}}
export default function MonsterScreenLayout(this: $MonsterScreenLayout) {
	$(this, "main", main, {x:1024, y:768});
	return this;
}
export function main(this: $main) {
	const buttons = this.buttons;
	$(buttons, 0, bodyButton, {x:-733.3, y:572, w:398.00, h: 392.00});
	$(buttons, 1, blegsButton, {x:-326.6, y:572, w:398.00, h: 392.00});
	$(buttons, 2, flegsButton, {x:80.1, y:572, w:398.00, h: 392.00});
	$(buttons, 3, headButton, {x:487.35, y:572, w:399.00, h: 392.00});
	$(this, "background", background, {x:-1664, y:-768, w:3328.80, h: 1536.00});
	$(this, "waterBack", waterBack, {x:-1976.95, y:241.85});
	$(this, "waterFront", waterFront, {x:-2205.4, y:377.65});
	$(this, "assembly", assembly, {x:0, y:0});
	return this;
}
function background(this: $background) {
	if (this.setLayoutTexture) this.setLayoutTexture("package.jpg", 0.000, 0.000);
	return this;
}
function waterBack(this: $waterBack) {
	const tiles = this.tiles;
	$(tiles, 0, waterBackSprite, {x:0, y:0, w:1184.00, h: 679.00});
	$(tiles, 1, waterBackSprite, {x:1184, y:0, w:1184.00, h: 679.00});
	$(tiles, 2, waterBackSprite, {x:2368, y:0, w:1184.00, h: 679.00});
	$(tiles, 3, waterBackSprite, {x:3552, y:0, w:1184.00, h: 679.00});
	return this;
}
function waterBackSprite(this: $waterBackSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("water-back.png", 0.000, 0.000);
	return this;
}
function waterFront(this: $waterFront) {
	const tiles = this.tiles;
	$(tiles, 0, waterFrontSprite, {x:0, y:0, w:1184.00, h: 679.00});
	$(tiles, 1, waterFrontSprite, {x:1184, y:0, w:1184.00, h: 679.00});
	$(tiles, 2, waterFrontSprite, {x:2368, y:0, w:1184.00, h: 679.00});
	$(tiles, 3, waterFrontSprite, {x:3552, y:0, w:1184.00, h: 679.00});
	return this;
}
function waterFrontSprite(this: $waterFrontSprite) {
	if (this.setLayoutTexture) this.setLayoutTexture("water-front.png", 0.000, 0.000);
	return this;
}
export function assembly(this: $assembly) {
	const blegs = this.blegs;
	$(blegs, 0, itemMonsterBlegsBack0, {x:-139, y:54.15, w:248.00, h: 283.00});
	$(blegs, 1, itemMonsterBlegsBack1, {x:-202.3, y:7.85, w:220.00, h: 210.00});
	$(blegs, 2, itemMonsterBlegsBack2, {x:-226.2, y:27.8, w:200.00, h: 297.00});
	$(blegs, 3, itemMonsterBlegsBack3, {x:-204.1, y:61.8, w:127.00, h: 190.00});
	$(blegs, 4, itemMonsterBlegsBack4, {x:-226.7, y:-10, w:149.00, h: 205.00});
	$(blegs, 5, itemMonsterBlegsBack5, {x:-214.65, y:44.55, w:62.00, h: 153.00});
	$(blegs, 6, itemMonsterBlegsFront0, {x:-262.25, y:27.4, w:314.00, h: 410.00});
	$(blegs, 7, itemMonsterBlegsFront1, {x:-257.75, y:-35.55, w:365.00, h: 255.00});
	$(blegs, 8, itemMonsterBlegsFront2, {x:-263.3, y:-50.2, w:414.00, h: 291.00});
	$(blegs, 9, itemMonsterBlegsFront3, {x:-250.65, y:-33.1, w:215.00, h: 238.00});
	$(blegs, 10, itemMonsterBlegsFront4, {x:-254.2, y:-54.9, w:284.00, h: 250.00});
	$(blegs, 11, itemMonsterBlegsFront5, {x:-260.5, y:-42.25, w:142.00, h: 128.00});
	const flegs = this.flegs;
	$(flegs, 0, itemMonsterFlegsBack0, {x:377.35, y:52.8, w:176.00, h: 363.00});
	$(flegs, 1, itemMonsterFlegsBack1, {x:292.65, y:104.75, w:193.00, h: 195.00});
	$(flegs, 2, itemMonsterFlegsBack2, {x:296.25, y:94.5, w:168.00, h: 189.00});
	$(flegs, 3, itemMonsterFlegsBack3, {x:318.65, y:76.45, w:274.00, h: 313.00});
	$(flegs, 4, itemMonsterFlegsBack4, {x:294.95, y:96.1, w:121.00, h: 162.00});
	$(flegs, 5, itemMonsterFlegsBack5, {x:271.85, y:88.75, w:151.00, h: 256.00});
	$(flegs, 6, itemMonsterFlegsFront0, {x:185.2, y:76.6, w:274.00, h: 432.00});
	$(flegs, 7, itemMonsterFlegsFront1, {x:207.5, y:53, w:281.00, h: 245.00});
	$(flegs, 8, itemMonsterFlegsFront2, {x:189, y:54.8, w:302.00, h: 263.00});
	$(flegs, 9, itemMonsterFlegsFront3, {x:196.35, y:43.8, w:460.00, h: 324.00});
	$(flegs, 10, itemMonsterFlegsFront4, {x:205.1, y:48.2, w:221.00, h: 230.00});
	$(flegs, 11, itemMonsterFlegsFront5, {x:198.35, y:48.2, w:240.00, h: 355.00});
	const body = this.body;
	$(body, 0, itemMonsterBody0, {x:-128.2, y:-201.35, w:1486.00, h: 662.00});
	$(body, 1, itemMonsterBody1, {x:-129.15, y:-96.35, w:1439.00, h: 468.00});
	$(body, 2, itemMonsterBody2, {x:-116.25, y:-150.95, w:1464.00, h: 576.00});
	$(body, 3, itemMonsterBody3, {x:-128.6, y:-71.45, w:1488.00, h: 697.00});
	$(body, 4, itemMonsterBody4, {x:-108.15, y:-169.4, w:1473.00, h: 933.00});
	$(body, 5, itemMonsterBody5, {x:-126.55, y:-177.5, w:1486.00, h: 710.00});
	const head = this.head;
	$(head, 0, itemMonsterHead0, {x:545.2, y:-88.4, w:489.00, h: 484.00});
	$(head, 1, itemMonsterHead1, {x:453.95, y:-97.75, w:645.00, h: 400.00});
	$(head, 2, itemMonsterHead2, {x:409.25, y:-78.85, w:517.00, h: 732.00});
	$(head, 3, itemMonsterHead3, {x:427.05, y:-66.7, w:740.00, h: 366.00});
	$(head, 4, itemMonsterHead4, {x:415.15, y:-66.9, w:834.00, h: 476.00});
	$(head, 5, itemMonsterHead5, {x:428.6, y:-69.15, w:503.00, h: 418.00});
	return this;
}
function itemMonsterBlegsBack0(this: $itemMonsterBlegsBack0) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-back-0.png", 0.379, 0.431);
	return this;
}
function itemMonsterBlegsBack1(this: $itemMonsterBlegsBack1) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-back-1.png", 0.777, 0.148);
	return this;
}
function itemMonsterBlegsBack2(this: $itemMonsterBlegsBack2) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-back-2.png", 0.610, 0.205);
	return this;
}
function itemMonsterBlegsBack3(this: $itemMonsterBlegsBack3) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-back-3.png", 0.913, 0.074);
	return this;
}
function itemMonsterBlegsBack4(this: $itemMonsterBlegsBack4) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-back-4.png", 0.396, 0.171);
	return this;
}
function itemMonsterBlegsBack5(this: $itemMonsterBlegsBack5) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-back-5.png", 0.613, 0.124);
	return this;
}
function itemMonsterFlegsBack0(this: $itemMonsterFlegsBack0) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-back-0.png", 0.494, 0.504);
	return this;
}
function itemMonsterFlegsBack1(this: $itemMonsterFlegsBack1) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-back-1.png", 0.679, 0.231);
	return this;
}
function itemMonsterFlegsBack2(this: $itemMonsterFlegsBack2) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-back-2.png", 0.643, 0.159);
	return this;
}
function itemMonsterFlegsBack3(this: $itemMonsterFlegsBack3) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-back-3.png", 0.916, 0.051);
	return this;
}
function itemMonsterFlegsBack4(this: $itemMonsterFlegsBack4) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-back-4.png", 0.529, 0.117);
	return this;
}
function itemMonsterFlegsBack5(this: $itemMonsterFlegsBack5) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-back-5.png", 0.464, 0.078);
	return this;
}
function itemMonsterBody0(this: $itemMonsterBody0) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-body-0.png", 0.500, 0.500);
	return this;
}
function itemMonsterBody1(this: $itemMonsterBody1) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-body-1.png", 0.500, 0.500);
	return this;
}
function itemMonsterBody2(this: $itemMonsterBody2) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-body-2.png", 0.500, 0.500);
	return this;
}
function itemMonsterBody3(this: $itemMonsterBody3) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-body-3.png", 0.500, 0.500);
	return this;
}
function itemMonsterBody4(this: $itemMonsterBody4) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-body-4.png", 0.500, 0.500);
	return this;
}
function itemMonsterBody5(this: $itemMonsterBody5) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-body-5.png", 0.500, 0.500);
	return this;
}
function itemMonsterBlegsFront0(this: $itemMonsterBlegsFront0) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-front-0.png", 0.592, 0.385);
	return this;
}
function itemMonsterBlegsFront1(this: $itemMonsterBlegsFront1) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-front-1.png", 0.797, 0.192);
	return this;
}
function itemMonsterBlegsFront2(this: $itemMonsterBlegsFront2) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-front-2.png", 0.792, 0.086);
	return this;
}
function itemMonsterBlegsFront3(this: $itemMonsterBlegsFront3) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-front-3.png", 0.893, 0.105);
	return this;
}
function itemMonsterBlegsFront4(this: $itemMonsterBlegsFront4) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-front-4.png", 0.708, 0.084);
	return this;
}
function itemMonsterBlegsFront5(this: $itemMonsterBlegsFront5) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-blegs-front-5.png", 0.894, 0.148);
	return this;
}
function itemMonsterFlegsFront0(this: $itemMonsterFlegsFront0) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-front-0.png", 0.515, 0.458);
	return this;
}
function itemMonsterFlegsFront1(this: $itemMonsterFlegsFront1) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-front-1.png", 0.783, 0.135);
	return this;
}
function itemMonsterFlegsFront2(this: $itemMonsterFlegsFront2) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-front-2.png", 0.695, 0.118);
	return this;
}
function itemMonsterFlegsFront3(this: $itemMonsterFlegsFront3) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-front-3.png", 0.937, 0.062);
	return this;
}
function itemMonsterFlegsFront4(this: $itemMonsterFlegsFront4) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-front-4.png", 0.633, 0.096);
	return this;
}
function itemMonsterFlegsFront5(this: $itemMonsterFlegsFront5) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-flegs-front-5.png", 0.421, 0.121);
	return this;
}
function itemMonsterHead0(this: $itemMonsterHead0) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-head-0.png", 0.149, 0.432);
	return this;
}
function itemMonsterHead1(this: $itemMonsterHead1) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-head-1.png", 0.322, 0.525);
	return this;
}
function itemMonsterHead2(this: $itemMonsterHead2) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-head-2.png", 0.124, 0.730);
	return this;
}
function itemMonsterHead3(this: $itemMonsterHead3) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-head-3.png", 0.332, 0.536);
	return this;
}
function itemMonsterHead4(this: $itemMonsterHead4) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-head-4.png", 0.392, 0.718);
	return this;
}
function itemMonsterHead5(this: $itemMonsterHead5) {
	if (this.setLayoutTexture) this.setLayoutTexture("item-monster-head-5.png", 0.181, 0.572);
	return this;
}
function flegsButton(this: $flegsButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("flegs-button.png", 0.500, 0.500);
	return this;
}
function blegsButton(this: $blegsButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("blegs-button.png", 0.500, 0.500);
	return this;
}
function headButton(this: $headButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("head-button.png", 0.501, 0.500);
	return this;
}
function bodyButton(this: $bodyButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("body-button.png", 0.500, 0.500);
	return this;
}
interface $$array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface $$container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface $$sprite extends $$container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface $$text extends $$container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface $$polygon extends Array<number> {
}
interface $MonsterScreenLayout {
	readonly main: $main;
}
interface $main extends $$container {
	readonly buttons: $$array<$bodyButton|$blegsButton|$flegsButton|$headButton>;
	readonly background: $background;
	readonly waterBack: $waterBack;
	readonly waterFront: $waterFront;
	readonly assembly: $assembly;
}
interface $background extends $$sprite {
}
interface $waterBack extends $$container {
	readonly tiles: $$array<$waterBackSprite>;
}
interface $waterBackSprite extends $$sprite {
}
interface $waterFront extends $$container {
	readonly tiles: $$array<$waterFrontSprite>;
}
interface $waterFrontSprite extends $$sprite {
}
interface $assembly extends $$container {
	readonly blegs: $$array<$itemMonsterBlegsBack0|$itemMonsterBlegsBack1|$itemMonsterBlegsBack2|$itemMonsterBlegsBack3|$itemMonsterBlegsBack4|$itemMonsterBlegsBack5|$itemMonsterBlegsFront0|$itemMonsterBlegsFront1|$itemMonsterBlegsFront2|$itemMonsterBlegsFront3|$itemMonsterBlegsFront4|$itemMonsterBlegsFront5>;
	readonly flegs: $$array<$itemMonsterFlegsBack0|$itemMonsterFlegsBack1|$itemMonsterFlegsBack2|$itemMonsterFlegsBack3|$itemMonsterFlegsBack4|$itemMonsterFlegsBack5|$itemMonsterFlegsFront0|$itemMonsterFlegsFront1|$itemMonsterFlegsFront2|$itemMonsterFlegsFront3|$itemMonsterFlegsFront4|$itemMonsterFlegsFront5>;
	readonly body: $$array<$itemMonsterBody0|$itemMonsterBody1|$itemMonsterBody2|$itemMonsterBody3|$itemMonsterBody4|$itemMonsterBody5>;
	readonly head: $$array<$itemMonsterHead0|$itemMonsterHead1|$itemMonsterHead2|$itemMonsterHead3|$itemMonsterHead4|$itemMonsterHead5>;
}
interface $itemMonsterBlegsBack0 extends $$sprite {
}
interface $itemMonsterBlegsBack1 extends $$sprite {
}
interface $itemMonsterBlegsBack2 extends $$sprite {
}
interface $itemMonsterBlegsBack3 extends $$sprite {
}
interface $itemMonsterBlegsBack4 extends $$sprite {
}
interface $itemMonsterBlegsBack5 extends $$sprite {
}
interface $itemMonsterFlegsBack0 extends $$sprite {
}
interface $itemMonsterFlegsBack1 extends $$sprite {
}
interface $itemMonsterFlegsBack2 extends $$sprite {
}
interface $itemMonsterFlegsBack3 extends $$sprite {
}
interface $itemMonsterFlegsBack4 extends $$sprite {
}
interface $itemMonsterFlegsBack5 extends $$sprite {
}
interface $itemMonsterBody0 extends $$sprite {
}
interface $itemMonsterBody1 extends $$sprite {
}
interface $itemMonsterBody2 extends $$sprite {
}
interface $itemMonsterBody3 extends $$sprite {
}
interface $itemMonsterBody4 extends $$sprite {
}
interface $itemMonsterBody5 extends $$sprite {
}
interface $itemMonsterBlegsFront0 extends $$sprite {
}
interface $itemMonsterBlegsFront1 extends $$sprite {
}
interface $itemMonsterBlegsFront2 extends $$sprite {
}
interface $itemMonsterBlegsFront3 extends $$sprite {
}
interface $itemMonsterBlegsFront4 extends $$sprite {
}
interface $itemMonsterBlegsFront5 extends $$sprite {
}
interface $itemMonsterFlegsFront0 extends $$sprite {
}
interface $itemMonsterFlegsFront1 extends $$sprite {
}
interface $itemMonsterFlegsFront2 extends $$sprite {
}
interface $itemMonsterFlegsFront3 extends $$sprite {
}
interface $itemMonsterFlegsFront4 extends $$sprite {
}
interface $itemMonsterFlegsFront5 extends $$sprite {
}
interface $itemMonsterHead0 extends $$sprite {
}
interface $itemMonsterHead1 extends $$sprite {
}
interface $itemMonsterHead2 extends $$sprite {
}
interface $itemMonsterHead3 extends $$sprite {
}
interface $itemMonsterHead4 extends $$sprite {
}
interface $itemMonsterHead5 extends $$sprite {
}
interface $flegsButton extends $$sprite {
}
interface $blegsButton extends $$sprite {
}
interface $headButton extends $$sprite {
}
interface $bodyButton extends $$sprite {
}
